import React from 'react'
import { Switch, Modal } from './'
import defaults from './defaults'
// TODO get modals from provider
import { modals } from '../../'
import withApp from '../../../core/provider/withApp'

class Modals extends React.Component {
  render() {
    return (
      <Switch>
        {defaults.map(modal => (
          <Modal key={modal.path} {...modal} />
        ))}

        {modals.map(modal => (
          <Modal key={modal.path} {...modal} />
        ))}

        {this.props.app.templates.modals.map(modal => (
          <Modal key={modal.path} {...modal} />
        ))}
      </Switch>
    )
  }
}

export default withApp(Modals)
